import v1airports from './v1airports'

export default {
  v1airports,
}
